// Environment detection helpers.
//
// The app runs in two environments:
//   • PREVIEW (dev)  -> hosted on *.preview.emergentagent.com
//   • PRODUCTION     -> hosted on the custom domain (e.g. teambuilder.rendeavored.com)
//
// We surface a persistent "TEST" indicator ONLY on the preview environment.
// Detection is fully automatic from the current hostname — never a user setting.

export const isPreviewEnv = () => {
  if (typeof window === "undefined") return false;
  const host = (window.location.hostname || "").toLowerCase();
  return host.endsWith(".preview.emergentagent.com");
};
